import { useContext } from 'react';

/**
 * Returns the current value for a context object, or throws an error in case there is no value
 * @param context - React.context
 * @param options - Parameters to build a descriptive error message. `options` object can contain following fields:
 *   * `hook` - string
 *   * `provider` - string
 *   * `shouldThrowError` - boolean
 * @returns current value for the given context
 * @example
 * import { useContextWithValidation } from '@adsk/alloy-react-helpers';
 *
 * export const useComponentContext = () =>
 *   useContextWithValidation(ComponentContext, {
 *     hook: 'useComponent',
 *     provider: 'ComponentProvider',
 *   });
 * @see DatePicker Notification
 */
export default function useContextWithValidation(context, options) {
  const contextValue = useContext(context);
  const {
    hook,
    provider,
    shouldThrowError
  } = options;
  const shouldError = shouldThrowError !== null && shouldThrowError !== void 0 ? shouldThrowError : true;
  if (!contextValue && shouldError) {
    throw new Error(`${hook} must be used within a ${provider}`);
  }
  return contextValue;
}
//# sourceMappingURL=useContextWithValidation.js.map